import React from 'react';
import { useAuthContext } from '@/hooks/useAuthContext';
import { usePartnerOverview } from '@/hooks/usePartnerOverview';
import { DashboardHeader } from './DashboardHeader';
import { DashboardKpiCards } from './DashboardKpiCards';
import { DashboardShareTools } from './DashboardShareTools';
import { DashboardRecentActivity } from './DashboardRecentActivity';
import { DashboardTierBenefits } from './DashboardTierBenefits';
import { DashboardPayoutCard } from './DashboardPayoutCard';

export const DashboardView: React.FC = () => {
  const { user, orgName, orgStatus } = useAuthContext();
  const { data } = usePartnerOverview();

  return (
    <div className="space-y-8">
      <DashboardHeader
        fullName={user?.fullName}
        orgStatus={orgStatus}
        orgName={orgName}
        tierDisplayName={data.tierDisplayName}
        referralUrl={data.referralUrl}
      />

      <DashboardKpiCards
        availableBalanceMinor={data.availableBalanceMinor}
        pendingClearanceMinor={data.pendingClearanceMinor}
        activeSubscriptions={data.activeSubscriptions}
        lifetimeEarningsMinor={data.lifetimeEarningsMinor}
        commissionRatePercent={data.commissionRatePercent}
      />

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 space-y-6">
          <DashboardShareTools
            referralCode={data.referralCode}
            referralUrl={data.referralUrl}
          />
          <DashboardRecentActivity
            transactions={data.recentTransactions}
            referralUrl={data.referralUrl}
          />
        </div>

        <div className="space-y-6">
          <DashboardTierBenefits
            tier={data.tier}
            tierDisplayName={data.tierDisplayName}
            commissionRatePercent={data.commissionRatePercent}
          />
          <DashboardPayoutCard
            availableBalanceMinor={data.availableBalanceMinor}
            minimumPayoutMinor={data.minimumPayoutMinor}
            payoutMethod={data.payoutMethod}
          />
        </div>
      </div>
    </div>
  );
};

export default DashboardView;
